import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ImageProviderService } from '../../../services';
import { ButtonComponent } from '../button/button.component';

@Component({
  selector: 'app-button-icon',
  templateUrl: './button-icon.component.html',
  styleUrls: ['./button-icon.component.scss'],
})
export class ButtonIconComponent extends ButtonComponent {
  @Input()
  set image(value: string) {
    this.source = value;
  }

  @Input()
  public apiSource: string;

  @Input()
  public alt: string;

  @Input()
  set active(value: boolean) {
    this._active = value;
  }

  get active() {
    return this._active;
  }

  @Input()
  public spinner = false;

  @Input()
  public disabled: boolean;

  @Input()
  public customClass = '';

  @Output()
  public clickHandler: EventEmitter<any>;

  public source: string;
  public _active = false;

  constructor(private imageService: ImageProviderService) {
    super();
    this.clickHandler = new EventEmitter();
  }

  /**
   * Maneja el evento de click del botón
   *
   * @param event evento click
   */
  public $clickHandler(event: Event): void {
    if (!this.disabled) {
      this.clickHandler.emit(event);
    }
  }
}
